import { Injectable } from '@angular/core';
import { Http, URLSearchParams } from '@angular/http';
import "rxjs/add/operator/map";
import { Observable } from "rxjs/Observable";
import { TmShopByCategory } from '../model/category';
import { TmProductResults } from '../model/product-results';
import { ApiBase } from './apibase.service';



export class Brand extends ApiBase {

    constructor(protected http: Http) {
        super(http);
    }

    get(dimension: string): Observable<TmProductResults> {
        //debugger;
        let urlParams: URLSearchParams = new URLSearchParams();


        if(dimension == 'primary_nav'){
            urlParams.set('fm', dimension);
        } else if (dimension != null && dimension.trim().length > 0)
            urlParams.set('dimension', dimension);

        return this.http
            .get(this.baseUrl + "/brand", { headers: this.cachebleHeaders, search: urlParams })
            .map(r => r.json() as TmProductResults)
            .catch(this.handleError);
    }
}(Brand as any).ctorParameters = function () { return [ { type: Http } ]; }

export class Category extends ApiBase {

    constructor(protected http: Http) {
        super(http);
    }

    get(): Observable<TmShopByCategory> {
        return this.http
            .get(this.baseUrl + "/shopbycategory", { headers: this.cachebleHeaders})
            .map(r => r.json() as TmShopByCategory)
            .catch(this.handleError);
    }
}(Category as any).ctorParameters = function () { return [ { type: Http } ]; }


// WEBPACK FOOTER //
// C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/ngc-webpack??ref--0-1!C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/angular2-template-loader!../tscapi/service/brand.service.ts